import { PayloadAction } from "@reduxjs/toolkit";

function changeColorState<T extends GeometricShape>(find: T, action: PayloadAction<{ id: number | string, propertyValue: ColorValue, propertyName: string }>): T {

    if (hasKey(find, action.payload.propertyName)) {
        find = { ...find, [action.payload.propertyName]: action.payload.propertyValue };
    } else {
        assertCorrectProperyName(action);
    }
    return find;
};

function changeNumberState<T extends GeometricShape>(find: T, action: PayloadAction<{ id: number | string, propertyValue: number, propertyName: string }>): T {
    if (hasKey(find, action.payload.propertyName)) {
        if (typeof find[action.payload.propertyName] === "number") {
            find = { ...find, [action.payload.propertyName]: action.payload.propertyValue };
        }
    } else {
        assertCorrectProperyName(action);
    }
    return find;
}
function changeStringState<T extends GeometricShape>(find: T, action: PayloadAction<{ id: number | string, propertyValue: string, propertyName: string }>): T {
    if (hasKey(find, action.payload.propertyName)) {
        if (typeof find[action.payload.propertyName] === "string") {
            find = { ...find, [action.payload.propertyName]: action.payload.propertyValue };
        }
    } else {
        assertCorrectProperyName(action);
    }
    return find;
}
function changeAnchorState<T extends GeometricShape>(find: T, action: PayloadAction<{ id: number | string, propertyValue: AnchorType, propertyName: string }>): T {
    if (hasKey(find, action.payload.propertyName)) {
        //todo: figure out something
        //if (typeof find[action.payload.propertyName] === "string") {
            find = { ...find, [action.payload.propertyName]: action.payload.propertyValue };
        //}
    } else {
        assertCorrectProperyName(action);
    }
    return find;
}

export function hasKey<O extends GeometricShape>(obj: O, key: PropertyKey): key is keyof O {
    return key in obj
}

function assertCorrectProperyName(action: PayloadAction<{ propertyName: string }>) {
    console.error(
        `${action.payload.propertyName} not valid string index. in change reducer: ${action.type}`
    )
};

export { changeColorState, changeNumberState, changeStringState, changeAnchorState }